
namespace Gamification.Gamification {

    export interface ProdottiPickerOptions {
        hideProdotti?: number[];
    }

    @Serenity.Decorators.registerClass()
    export class ProdottiCheckGrid extends Serenity.EntityGrid<ProdottiRow, ProdottiPickerOptions> {
        protected getColumnsKey() { return ProdottiColumns.columnsKey; }
        protected getDialogType() { return ProdottiDialog; }
        protected getIdProperty() { return ProdottiRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiRow.localTextPrefix; }
        protected getService() { return ProdottiService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery, options: ProdottiPickerOptions) {
            super(container, options);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            return columns;
        }

        protected usePager() {
            return true;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            //
            var request = this.view.params as Serenity.ListRequest;
            //
            if (this.options.hideProdotti && this.options.hideProdotti.length) {
                /* */
                request.Criteria = Serenity.Criteria.and([[Gamification.ProdottiRow.Fields.IdProdotto], 'not in', [this.options.hideProdotti]], request.Criteria);
            }

            return true;
        }
    }
}